import React from 'react';
import { Link } from 'react-router-dom';
import '../styles/NosotrosPage.css';

const NosotrosPage = () => {
  const valores = [
    {
      icon: '🌱',
      title: 'Sostenibilidad',
      description: 'Comprometidos con el cuidado del medio ambiente en cada servicio que ofrecemos.'
    },
    {
      icon: '🏆',
      title: 'Excelencia',
      description: 'Buscamos la máxima calidad en cada proyecto y servicio que realizamos.'
    },
    {
      icon: '🤝',
      title: 'Integridad',
      description: 'Actuamos con honestidad, transparencia y ética profesional.'
    },
    {
      icon: '💡',
      title: 'Innovación',
      description: 'Implementamos tecnología y metodologías de vanguardia.'
    },
    {
      icon: '❤️',
      title: 'Compromiso',
      description: 'Dedicación total al éxito de nuestros clientes y colaboradores.'
    },
    {
      icon: '👥',
      title: 'Trabajo en Equipo',
      description: 'Valoramos la colaboración y el aporte de cada miembro del equipo.'
    }
  ];

  return (
    <div className="nosotros-page">

      {/* HERO CON IMAGEN DE FONDO */}
      <section className="page-hero">
        <div className="page-hero-overlay" />
        <div className="page-hero-content">
          <p className="page-hero-tagline">Quiénes somos</p>
          <h1>Sobre Nosotros</h1>
          <p>Más de 20 años de experiencia en limpieza profesional</p>
        </div>
      </section>

      {/* RESEÑA HISTÓRICA */}
      <section className="about-intro">
        <div className="container">
          <div className="intro-content">
            <div className="intro-text">
              <h2>Reseña Histórica</h2>
              <p>
                Ecolimpieza A&amp;G es una empresa familiar creada con el propósito de brindar servicios
                de limpieza profesional con responsabilidad, compromiso y altos estándares de calidad,
                orientados a satisfacer las necesidades de hogares, oficinas, empresas y proyectos
                de construcción.
              </p>
              <p>
                Nuestra empresa nace respaldada por más de 20 años de experiencia en el rubro de
                limpieza, trayectoria desarrollada a través de la supervisión de operaciones y equipos
                de trabajo en diversas ciudades y 8 regiones del Perú. Esta experiencia nos ha permitido
                adquirir sólidos conocimientos en gestión operativa, manejo de personal, control de
                calidad y atención al cliente, garantizando servicios eficientes, seguros y confiables.
              </p>
              <p>
                A lo largo de los años hemos comprendido que la limpieza no solo representa una
                necesidad, sino también una parte fundamental de la imagen, seguridad y bienestar
                de cada espacio. Por ello, trabajamos con profesionalismo, puntualidad y dedicación,
                ofreciendo soluciones integrales adaptadas a los requerimientos de cada cliente.
              </p>
              <p>
                El nombre <strong>Ecolimpieza A&amp;G</strong> nace en memoria de nuestro padre y nuestro
                hermano, quienes continúan siendo nuestra inspiración y el motor que impulsa nuestro
                crecimiento. Sus valores de esfuerzo, honestidad, compromiso y dedicación forman parte
                de la esencia de nuestra empresa y se reflejan en cada servicio que realizamos.
              </p>
              <p>
                Actualmente, brindamos servicios especializados como limpieza de oficinas, lavado de
                alfombras, limpieza de muebles y tapicería, limpieza profunda, limpieza final de
                construcción y mantenimiento integral de espacios, consolidándonos como una empresa
                comprometida con la calidad y la satisfacción de nuestros clientes.
              </p>
              <p className="about-tagline">✨ Experiencia, compromiso y confianza en cada servicio.</p>
            </div>

          </div>
        </div>
      </section>

      <section className="mission-vision">
        <div className="container">
          <div className="mv-grid">
            <div className="mv-card">
              <h3>Nuestra Misión</h3>
              <p>
                Ofrecer servicios integrales de limpieza y facilities management de la más alta
                calidad, utilizando productos ecológicos y prácticas sostenibles, para contribuir
                al bienestar de las personas y al cuidado del medio ambiente.
              </p>
            </div>
            <div className="mv-card">
              <h3>Nuestra Visión</h3>
              <p>
                Ser reconocidos como la empresa líder en servicios integrales de limpieza y gestión
                de facilities en el Perú, destacándonos por nuestra innovación, compromiso ambiental
                y excelencia en el servicio al cliente.
              </p>
            </div>
          </div>
        </div>
      </section>

      <section className="valores-section">
        <div className="container">
          <h2>Nuestros Valores</h2>
          <p className="section-description">
            Los principios que guían nuestro actuar y definen nuestra cultura organizacional
          </p>
          <div className="valores-grid">
            {valores.map((valor, index) => (
              <div key={index} className="valor-card">
                <div className="valor-icon">{valor.icon}</div>
                <h3>{valor.title}</h3>
                <p>{valor.description}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="why-choose">
        <div className="container">
          <h2>¿Por Qué Elegirnos?</h2>
          <div className="why-grid">
            <div className="why-item">
              <div className="why-number">20+</div>
              <h4>Años de Experiencia</h4>
              <p>Trayectoria sólida en el mercado peruano</p>
            </div>
            <div className="why-item">
              <div className="why-number">8</div>
              <h4>Regiones del Perú</h4>
              <p>Presencia a nivel nacional</p>
            </div>
            <div className="why-item">
              <div className="why-number">100%</div>
              <h4>Compromiso</h4>
              <p>Dedicación en cada servicio</p>
            </div>
            <div className="why-item">
              <div className="why-number">24/7</div>
              <h4>Disponibilidad</h4>
              <p>Atención y soporte en todo momento</p>
            </div>
          </div>
        </div>
      </section>

      <section className="cta-section">
        <div className="container">
          <h2>¿Listo para trabajar con nosotros?</h2>
          <p>Contáctenos y descubra cómo podemos ayudar a su empresa</p>
          <Link to="/contacto" className="btn-primary">Contactar Ahora</Link>
        </div>
      </section>

    </div>
  );
};

export default NosotrosPage;
